import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import StatsStrip from "../components/StatsStrip";
import Services from "../components/Services";
import Packages from "../components/Packages";
import Gallery from "../components/Gallery";
import About from "../components/About";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <div
      data-testid="home-page"
      className="min-h-screen bg-[#050505] text-white font-body overflow-hidden"
    >
      <Navbar />
      <main>
        <Hero />
        <StatsStrip />
        <Services />
        <Packages />
        <Gallery />
        <About />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
